export enum ChoiceProperties {
  Label = 'label',
  Value = 'value',
  Data = 'data',
}
